const STRIPE_LEGACY_USER_AGENT_PATTERN = /edge\/|msie|trident/i;

export const isStripeLegacyUserAgent = (userAgent: string) => STRIPE_LEGACY_USER_AGENT_PATTERN.test(userAgent);
